export default __webpack_public_path__ + "static/HeroImage-1cd240eaf340a0151ef1de1f76d4f82d.jpg";